import { render } from "./ServiceCard.vue?vue&type=template&id=9263afa0&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&lang=js"
export * from "./ServiceCard.vue?vue&type=script&lang=js"

import "./ServiceCard.vue?vue&type=style&index=0&id=9263afa0&scoped=true&lang=css"
import "./ServiceCard.vue?vue&type=style&index=1&id=9263afa0&lang=css"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9263afa0"]])

export default __exports__